/** The API's marker for AI output built in part on Garmin rides (``ai_sources``). */
export const GARMIN_SOURCE = 'garmin_connect';

/** Whether an AI output's ``ai_sources`` include Garmin (show the attribution line). */
export function usesGarmin(sources: readonly string[] | null | undefined): boolean {
  return !!sources?.includes(GARMIN_SOURCE);
}
